const emptyMetrics = () => ({
  previstoNf: { quantidade: 0, valor: 0 },
  realizadoCte: { quantidadeCte: 0, quantidade: 0, valor: 0 },
  aRealizarNfsCte: { quantidade: 0, valor: 0 },
  realizadoFatura: { quantidade: 0, quantidadeCte: 0, valor: 0 },
  aRealizarFatura: { quantidade: 0, quantidadeCte: 0, valor: 0 },
});

const pickMetrics = (row) => ({
  previstoNf: row.previstoNf || emptyMetrics().previstoNf,
  realizadoCte: row.realizadoCte || emptyMetrics().realizadoCte,
  aRealizarNfsCte: row.aRealizarNfsCte || emptyMetrics().aRealizarNfsCte,
  realizadoFatura: row.realizadoFatura || emptyMetrics().realizadoFatura,
  aRealizarFatura:
    row.aRealizarFatura || emptyMetrics().aRealizarFatura,
});

export function buildTree(rows) {
  if (!Array.isArray(rows) || rows.length === 0) return [];

  const transpMap = new Map();

  rows.forEach((r) => {
    const tKey = `t${r.transportadoraId}`;
    if (r.nivel === 0) {
      transpMap.set(tKey, {
        key: tKey,
        nivel: 0,
        label: r.transportadoraFantasia || "(Sem nome)",
        metrics: pickMetrics(r),
        recorte: { transportadoraId: r.transportadoraId },
        children: new Map(),
      });
      return;
    }

    const tNode = transpMap.get(tKey);
    if (!tNode) return;

    const nKey = `${tKey}.n${r.negocioId}`;
    if (r.nivel === 1) {
      tNode.children.set(nKey, {
        key: nKey,
        nivel: 1,
        label: r.negocioNome || "(Sem negócio)",
        metrics: pickMetrics(r),
        recorte: {
          transportadoraId: r.transportadoraId,
          negocioId: r.negocioId,
        },
        children: new Map(),
      });
      return;
    }

    const nNode = tNode.children.get(nKey);
    if (!nNode) return;

    const eKey = `${nKey}.e${r.estadoId}`;
    if (r.nivel === 2) {
      nNode.children.set(eKey, {
        key: eKey,
        nivel: 2,
        label: r.estadoSigla || "(Sem UF)",
        metrics: pickMetrics(r),
        recorte: {
          transportadoraId: r.transportadoraId,
          negocioId: r.negocioId,
          estadoId: r.estadoId,
        },
        children: new Map(),
      });
      return;
    }

    const eNode = nNode.children.get(eKey);
    if (!eNode) return;

    const rKey = `${eKey}.r${r.regiaoFreteId || "none"}`;
    if (r.nivel === 3) {
      eNode.children.set(rKey, {
        key: rKey,
        nivel: 3,
        label: r.regiaoNome || "(Sem região)",
        metrics: pickMetrics(r),
        recorte: {
          transportadoraId: r.transportadoraId,
          negocioId: r.negocioId,
          estadoId: r.estadoId,
          regiaoFreteId: r.regiaoFreteId,
        },
        children: new Map(),
      });
    }
  });

  const mapToArray = (m) =>
    [...m.values()].map((n) => ({
      ...n,
      children: mapToArray(n.children),
    }));

  return mapToArray(transpMap);
}

export function flattenVisible(tree, expanded) {
  const out = [];
  const walk = (nodes) => {
    nodes.forEach((n) => {
      out.push(n);
      if (expanded.has(n.key) && n.children.length > 0) walk(n.children);
    });
  };
  walk(tree);
  return out;
}

export function collectAllKeys(tree) {
  const keys = new Set();
  const walk = (nodes) => {
    nodes.forEach((n) => {
      if (n.children.length > 0) keys.add(n.key);
      walk(n.children);
    });
  };
  walk(tree);
  return keys;
}

export function collectInitialExpanded(tree) {
  const keys = new Set();
  tree.forEach((t) => {
    keys.add(t.key);
    t.children.forEach((n) => {
      if (n.children.length > 0) keys.add(n.key);
    });
  });
  return keys;
}
